module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ac92bfcb2fc35687d1ba5ab6bb733671.svg";